import client from '../../client'
import { GradesListResponse } from './types'

export * from './types'

export const list = async () => {
  const { data } = await client.get<GradesListResponse>('/user/grades')
  return data
}
